import FieldPayerIsCustomer from './FieldPayerIsCustomer';
export default FieldPayerIsCustomer;
